import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Wrapper padrão para revelar seções com scroll (whileInView).
 * Respeita prefers-reduced-motion e cai para render simples se necessário.
 */
export default function Reveal({
  children,
  y = 24,
  delay = 0,
  duration = 0.7,
  once = true,
  className = "",
  as: Tag = "div",
  ...rest
}) {
  const prefersReduced = useReducedMotion();
  if (prefersReduced) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
